<script>
import { iAlertMessage } from '@inscribe/signal';
import { RISK_LEVEL, VERIFICATION_RESULT } from '@/constants/analyst-constants';
import { RISKS_CONFIG } from '@/constants/analyst-config';

export default {
  components: {
    iAlertMessage,
  },
  props: {
    risk: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      RISKS_CONFIG,
    };
  },
  computed: {
    bannerData() {
      const riskConfig = RISKS_CONFIG[this.risk];
      const returnObject = {
        title: riskConfig?.label || '',
      };
      switch (this.risk) {
        case RISK_LEVEL.LOW:
        case VERIFICATION_RESULT.LOW_RISK:
          returnObject.type = 'success';
          break;
        case RISK_LEVEL.NOT_APPLICABLE:
          returnObject.type = 'neutral';
          break;
        case RISK_LEVEL.MEDIUM:
        case VERIFICATION_RESULT.INCONCLUSIVE:
          returnObject.type = 'warning';
          break;
        case RISK_LEVEL.HIGH:
        case VERIFICATION_RESULT.HIGH_RISK:
          returnObject.type = 'error';
          break;
      }
      return returnObject;
    },
  },
};
</script>

<template>
  <i-alert-message
    :type="bannerData.type"
    :heading="bannerData.title"
    size="sm"
    class="risk-alert-message"
  ></i-alert-message>
</template>

<style lang="scss" scoped>
.risk-alert-message {
  height: 36px;
  align-items: center;
  border-radius: 8px !important;

  :deep(svg) {
    width: 16px !important;
    height: 16px !important;
  }

  :deep(h4) {
    font-weight: 600 !important;
  }
}
</style>
